"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.CategoryItemFactory = exports.CategoryLevelFactory = exports.CategoryFactory = void 0;
var utils_1 = require("../utils");
exports.CategoryFactory = {
    createInstance: function (params) {
        var defaultProps = {
            props: {}
        };
        var _a = __assign(__assign({}, defaultProps), params), published = _a.published, props = _a.props, levels = _a.levels;
        var category = {
            levels: levels,
            props: props,
            published: published,
            uuid: utils_1.UUIDs.v4()
        };
        return __assign(__assign({}, category), { levels: levels || [
                exports.CategoryLevelFactory.createInstance({ categoryUuid: category.uuid, index: 0, props: { name: 'level_1' } }),
            ] });
    }
};
exports.CategoryLevelFactory = {
    createInstance: function (params) {
        var defaultProps = {
            props: {},
            index: 0
        };
        var _a = __assign(__assign({}, defaultProps), params), index = _a.index, categoryUuid = _a.categoryUuid, props = _a.props;
        return {
            categoryUuid: categoryUuid,
            index: index,
            props: props,
            uuid: utils_1.UUIDs.v4()
        };
    }
};
exports.CategoryItemFactory = {
    createInstance: function (params) {
        var defaultProps = {
            props: {}
        };
        var _a = __assign(__assign({}, defaultProps), params), levelUuid = _a.levelUuid, parentUuid = _a.parentUuid, props = _a.props;
        return {
            uuid: utils_1.UUIDs.v4(),
            levelUuid: levelUuid,
            parentUuid: parentUuid,
            props: props
        };
    }
};
//# sourceMappingURL=factory.js.map